import React, { useEffect } from 'react';
import './Cybersecurityscams.css';

const CybersecurityScams = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const scamTypes = [
    { title: '🎣 Phishing Attacks', desc: 'Fraudulent emails or websites that mimic legitimate companies' },
    { title: '📞 Phone Scams', desc: 'Scammers posing as broker representatives' },
    { title: '💰 Guaranteed Returns', desc: 'Promises of unrealistic returns with zero risk' },
    { title: '🤖 Fake Trading Bots', desc: 'Software claiming to generate automatic profits' },
    { title: '👥 Social Media Impersonation', desc: 'Fake accounts impersonating Meta Frx Ai staff' },
    { title: '🔓 Account Takeover', desc: 'Unauthorized access to your trading account' }
  ];

  return (
    <div className="page-container">
      <div className="container">
        <button className="back-button" onClick={() => window.history.back()}>
          <span>←</span><span>Back to Home</span>
        </button>

        <h1>Cybersecurity and Scams</h1>
        <p className="subtitle">Your security is our top priority. Learn how to protect yourself from fraud.</p>

        <div className="warning-box">
          <h3>⚠️ Important Warning</h3>
          <p>Meta Frx Ai will never ask you for your password via email, phone, or any other communication channel.</p>
        </div>

        <div className="section">
          <h2>Common Trading Scams</h2>
          <div className="scam-types">
            {scamTypes.map((scam, index) => (
              <div key={index} className="scam-card">
                <h4>{scam.title}</h4>
                <p>{scam.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="section">
          <h2>How to Protect Yourself</h2>
          <ul className="tips-list">
            <li>Never share your password with anyone</li>
            <li>Enable Two-Factor Authentication (2FA)</li>
            <li>Always verify the URL before logging in</li>
            <li>Use strong, unique passwords</li>
            <li>Be cautious of unsolicited calls or emails</li>
          </ul>
        </div>

        <div className="contact-section">
          <h3>Report Suspicious Activity</h3>
          <p><strong>Email:</strong> security@Meta Frx Ai.com</p>
          <p><strong>Phone:</strong> +1-800-Meta Frx Ai</p>
        </div>
      </div>
    </div>
  );
};

export default CybersecurityScams;